<template>
  <v-card elevation="2" class="mx-auto ma-5">
    <v-btn @click="addToCart" :color="isInCart ? 'success' : 'primary'">
      <v-icon dark>mdi-cart-plus</v-icon>
    </v-btn>
    <a class="notice-link" :href="notice.url">
      <v-row align="center" justify="center" class="px-3" style="min-: 175px">
        <v-col cols="2">
          <v-img
              :src="notice.images.medium"
              :lazy-src="notice.images.lazy"
              max-width="150" max-height="150" v-if="notice.images && notice.images.medium">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="red"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
        <v-col cols="10">
          <h4 v-if="notice.titles.title">{{ notice.titles.title }}</h4>
          <h4 v-else>{{ notice.title }}</h4>
          <h5 v-if="notice.titles.subTitle">{{ notice.titles.subTitle }}</h5>
          <h6 v-if="notice.titles.text">{{ notice.titles.text }}</h6>
        </v-col>
      </v-row>
    </a>
  </v-card>
</template>

<script>

export default {
  name: 'FrontNoticeItems',
  props: [
    'notice',
  ],
  computed: {
    isInCart: function () {
      return (this.$store.state.cart.indexOf(this.notice.id) !== -1)
    }
  },
  methods: {
    addToCart() {
      if(this.$store.state.cart.indexOf(this.notice.id) !== -1){
        this.$store.commit('removeFromCart', this.notice.id)
      } else{
        this.$store.commit('addToCart', this.notice.id)
      }
    }
  }
}
</script>
